import ResponsiveVideo from '../components/ResponsiveVideo';

export default class VideoPlayer {
	constructor(el) {

		this.el = el;
		this.video = this.el.querySelector('[data-video]');
		this.poster = this.el.querySelector('[data-poster]');
		this.playButton = this.el.querySelector('[data-play-button]');
		this.pauseText = this.el.querySelector('[data-pause-text]');


		this.playButton.addEventListener('click', (e) => {
			const isPlaying = !this.video.paused;

			if(!isPlaying) {
				this.poster.classList.add('is-hidden');

				this.play();

				this.pauseText.classList.add('changeOpacity');
			}
		});

		this.init();
	}

	init() {
		if(this.video) {
			new ResponsiveVideo(this.video);
		}
	}

	play() {
		this.video.play();
	}
}